const Axios         = require('axios');

class Metrics {
    constructor(app, config) {

        this.app = app;
        let event = app.events;

        if (!event.subscribeAll) {
            // console.log("Event object not supported");
            return
        }

        let index        = 0;
        this.teasers     = {};
        this.viewTeasers = {};
        this.teasersLoad = {};

        this.config      = {
            percent  : config.percent  || 0.6,
            host     : config.host     || '',
            url      : config.url      || '',
            interval : config.interval || 200,
        };


        event.addObserverList("METRICS_SHOW_TEASER");

        // console.log('metric conf', this.config);



        event.subscribeAll((data, type) => {

            if (type === 'EVENT_LOAD_PAGE') {
                let index        = 0;
                this.teasers     = {};
                this.viewTeasers = {};
                this.teasersLoad = {};
            }

            if (type === 'EVENT_LOAD_TEASERS') {
                // console.log("EVENT_LOAD_TEASERS ", data);

                for (let i in data) {
                    this.teasersLoad[data[i].teaser_id] = data[i];
                }

                document.querySelectorAll("[data-teaser]").forEach(e => {
                    if (!e.dataset.teaser) return;

                    let id = e.dataset.teaser;
                    let index = e.dataset.index;
                    let teaserId = e.dataset.id;
                    let position = e.dataset.position;
                    // console.log("e.dataset.id", e.dataset.id);
                    // console.log("this.viewTeasers[index]", this.viewTeasers[index]);
                    if (this.viewTeasers[index + ' ' + teaserId]) return;

                    //this.viewTeasers.push(e);


                    this.viewTeasers[index + ' ' + teaserId] = e;
                    this.teasers[index + ' ' + teaserId] = {
                        id: id,
                        element: e,
                        index: index,
                        isView: false,
                        isClick: false,
                        isSend: false,
                        page: data,
                        // position: (this.teasersLoad[teaserId])  ? this.teasersLoad[teaserId].position : 0
                        position: Number(position)
                    };

                });

                // console.log("this.teasers", this.teasers);
                //
                // console.log("this.teasersLoad", this.teasers);

                // console.log('this.teasers',this.teasers);
                // Находим элементы которые показал
                let onScroll = () => {
                    this.note();
                };

                onScroll();

                window.removeEventListener('scroll', onScroll);
                window.addEventListener('scroll', onScroll);
            }
            // onClick teaser
            else if (type === 'EVENT_TEASER_CLICK') {

                // if (data.teaser.teaser_id && this.teasers[data.teaser.teaser_id])
                //     this.teasers[data.teaser.teaser_id].isClick = true;

            }
        });

        window.addEventListener('beforeunload', () => {this._send(); });


        setInterval(() => {

            this._send()
        }, this.config.interval)

    }

    clear() {
        this.teasers     = {};
        this.viewTeasers = {};
        this.teasersLoad = {};
    }
    note(){
        for (let i in this.viewTeasers) {
            if (this.teasers[i].isView === true) continue;

            if (this.IsVisibleElement(this.viewTeasers[i], this.config.percent)) {
                let e = this.viewTeasers[i];
                // let id = e.dataset.teaser;
                this.teasers[i].isView = true;
                this.app.events.notify('METRICS_SHOW_TEASER', this.teasers[i])

            }
        }
    }



    _send() {
        let teaserIds = [];
        // let connect = this.app.connectionSpeedObj();
        // let width = screen.width;
        // let height = screen.height;
        for (let i in this.teasers) {
            // console.log(i, 'this.teasers', this.teasers[i]);
            if (this.teasers[i].isView && !this.teasers[i].isSend) {
                teaserIds.push({
                    data: this.teasers[i].id,
                    position: this.teasers[i].position,
                });
                this.teasers[i].isSend = true;
            }
        }

        if (teaserIds.length === 0) return;


        let data = JSON.stringify({
            teasers: teaserIds,
            sid9: String(this.app.sid9),
            // connectType: connect.type,
            // connectSpeed: connect.speed,
            // width,
            // height,
        });
///////////////////
//         let resp =  this.app.ajaxPull.post({uri: this.config.url}, data, {
//             baseURL: this.config.host,
//
//             headers:{'Content-Type': 'application/json'},
//             onBeforeRequest: (conf) => {
//                 // conf.data = Qs.stringify(conf.data);
//             },
//         });
//         resp.onSuccess((response) => {
//             if (this.app.isDebug()) {
//                 for (let i in teaserIds) {
//                     document.querySelector("[data-teaser='"+teaserIds[i].data+"']").style.border="2px solid red";
//                 }
//             }
//         });
//
//         resp.onFail((response) => {
//             for (let i in teaserIds) {
//                 this.teasers[i].isSend = false;
//             }
//         });

//////////////////////////////////

        let headers = {
            'Content-Type': 'application/json'
        };

        let instance = Axios.create({
            baseURL         : this.config.host,
            timeout         : 30000,
            withCredentials : true,
            responseType    : 'json',
        });

        instance.request({
            method: 'post',
            url: this.config.url,
            data: data,
            headers: headers

        }).then((response) =>{

            if (this.app.debug.isDebug()) {
                for (let i in teaserIds) {
                   let el =  document.querySelector("[data-teaser='"+teaserIds[i].data+"']");

                   if (el && el.style) {
                       el.style.border="2px solid red"
                   }

                }
            }

            })
            .catch((error) => {
                console.error(error)
                for (let i in teaserIds) {
                    this.teasers[i].isSend = false;
                }
            });
    }

    IsVisibleElement(element, percent) {
        if (!percent) percent = 1;

        let param = element.getBoundingClientRect();
        let height = param.height * percent;

        return (window.outerHeight > param.y + height
            && param.y + height > 0);
    };
}


module.exports = Metrics;
